import CompactEmptyState from 'components/EmptyState/CompactEmptyState';
import useText from 'hooks/useText';
import { firstNameOf, splitLines } from 'pages/prospection/callListItems';

/**
 * The right column while calls remain and no call sheet is open. With a queue
 * and no line brought forward, it offers to launch the session; otherwise it
 * offers to call the highlighted line, or the first one to call.
 */
const IdlePanel = ({ pending, highlightedLine, onLaunch, onCall }) => {
  const { text, plural } = useText('prospection');
  const { queue } = splitLines(pending);
  const launching = queue.length > 0 && !highlightedLine;
  const target = highlightedLine || pending[0];

  const action = launching
    ? { label: text('idle.launch'), onClick: onLaunch }
    : {
        label: text('idle.callButton', {
          name: firstNameOf(target.company?.contactName, target.company?.name),
        }),
        onClick: () => onCall(target),
      };

  return (
    <div className="flex h-full min-h-[360px] items-center justify-center rounded-xl border-2 border-dashed border-gray-200 px-6">
      <CompactEmptyState
        compact
        glyph="hourglass"
        title={text('idle.title')}
        description={
          launching ? plural('idle.launch', queue.length) : text('idle.call')
        }
        action={action}
        actionColor="PRIMARY"
      />
    </div>
  );
};

export default IdlePanel;
